import MDModal from 'components/MDModal';
import React, { useState, useEffect } from 'react';
import "../style.css";
import { useAgencyInfo } from 'context/agency';
import CreatePromptCategory from '../PromptCategory/Create';
import { useAgencyPromptCategories, useCreatePromptCategory } from 'queries/promptCategories';

function Create({ openModel, onclosemodel, data, modelfunctionality }) {
  const [agency] = useAgencyInfo();
  const [formData, setFormData] = useState({
    name: '',
    category_id: '',
    type: 'agency-admin'
  });
  const [subCategories, setSubCategories] = useState([]);
  const [isCategoryModel, setIsCategoryModel] = useState(false);
  const [isSubCategoryModel, setIsSubCategoryModel] = useState(false);

  useEffect(() => {
    if (data) {
      setFormData({
        name: data.name || '',
        category_id: data.category_id || '',
      });
    }
  }, [data]);

  const { data: categories = [] } = useAgencyPromptCategories(agency?._id);

  const { mutateAsync: createPromptCategory } = useCreatePromptCategory();

  const handleCategoryChange = async (e) => {
    const category_id = e.target.value;
    setFormData({
      ...formData,
      category_id,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    modelfunctionality(formData);
  };

  const handleSavePromptCategory = async (formData) => {
    const updatedFormData = { ...formData, agency_id: agency._id };
    const { response } = await createPromptCategory(updatedFormData);
    if (response) {
      closeCateggoryModel();
    }
  }

  const handleCategoryModel = () => {
    setIsCategoryModel(true);
  }

  const closeCateggoryModel = () => {
    setIsCategoryModel(false);
  }

  const handleSubCategoryModel = () => {
    setIsSubCategoryModel(true);
  }

  const closeSubCateggoryModel = () => {
    setIsSubCategoryModel(false);
  }

  return (
    <div>
      {openModel &&
        <div className="modal-zz-confirm text-left"  >

          <div className="scrollable-modal-content bg-white  rounded" style={{ position: "relative" }}>
            <h2 className='text-black text-left font-14'> Create Prompt Sub Category
            </h2>
            <span className='crossison' onClick={onclosemodel}>X</span>
            <div>
              {data && (
                <h2 className='font14'>
                  <span className='new_dezin_label text-black '>Sub Category: </span>{data.title}
                </h2>
              )}
              <form onSubmit={handleSubmit}>
                <div className='w-100 margin_fix'>
                  <div>
                    <label className='new_dezin_label text-black '>Name</label>
                  </div>
                  <div>
                    <input
                      type="text"
                      name='name'
                      className='w-100 form-control-agust'
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className='w-100 margin_fix'>
                  <div className='w-100 d-flex justify-content-between'>
                    <label className='w-50 new_dezin_label text-black '>Category</label>
                    <p className='w-50 text-right new_dezin_label text-black cursor-pointer' onClick={handleCategoryModel}>+ Add Category</p>
                  </div>
                  <div>
                    <select
                      name='category'
                      className='w-100 selectstyle'
                      value={formData.category}
                      onChange={handleCategoryChange}
                    >
                      <option value="">Select a category</option>
                      {categories?.map(cat => (
                        <option key={cat._id} value={cat._id}>{cat.name}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className='w-100 margin-top-20px'>
                  <button type='submit' className='btn-newdezine cursor-pointer'>Save</button>
                </div>
              </form>
            </div>
          </div>
        </div>}

      {isCategoryModel && (
        <CreatePromptCategory modelfunctionality={handleSavePromptCategory} openModel={isCategoryModel} onclosemodel={closeCateggoryModel} />
      )}
    </div>
  );
}

export default Create;
